import React from "react";

import {
  Paper, Typography, Grid
} from "@material-ui/core";

import PhoneIcon from "@material-ui/icons/LocalPhoneOutlined";

import classes from "../../css/getCSS";

const StaffUserInfo = (props) => {
  console.log('StaffUserInfo===props', props);

  return (<React.Fragment>
    <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(" ")}>
      <Typography variant="subheading" className={classes.profileSectionTitle}>
        <PhoneIcon className={classes.titleIcon} />
        Zonal Admin Info
      </Typography>
      <br />
        <React.Fragment>
          {/*<br/>*/}
          {props.profile.admin_email.map((data) => {
          return(
            <Grid container className={classes.userInfoDetails}>
              <Grid item md={6} sm={6} xs={12}>
                <p className={classes.profileCap}>Name</p>
                <p className={classes.profileVal}>{data.name}</p>
                <br />
              </Grid>
              <Grid item md={6} sm={6} xs={12}>
                <p className={classes.profileCap}>Contact no.</p>
                <p className={classes.profileVal}>{data.phone}</p>
                <br />
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <p className={classes.profileCap}>Contact email</p>
                <p className={classes.profileVal}>{data.email}</p>
                <br />
              </Grid>
          </Grid>
          )
        })}
          <p className={classes.profileCap} style={{color: "#ff0000"}}>Any further information please contact to respective zonal admins.</p>
        </React.Fragment>
    </Paper>
  </React.Fragment>);
};


export default StaffUserInfo;



// WEBPACK FOOTER //
// ./src/profile/components/StaffUserInfo.js